import { Box, Tab, Tabs } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { TabContext, TabPanel } from '@mui/lab';
import { colorBrandObject } from '../../../constants/brandings';
import BoxPayGrid from '../BoxPayGrid';
import { useAuth } from '../../context/API_Client';
import { approvalWorkflowSchema } from './ApprovalSchema';
import { customToast } from '../../reusableComponents/customToaster/customToast';
import { PAGE_LIST } from '../utils/utils';
import { completedWorkflowSchema } from './CompletedSchema';
import RejectModal from './RejectModal';
import InputSearch from '../../reusableComponents/InputSearch/InputSearch';

function ApprovalRequest() {
    const [value, setValue] = useState("0");
    const [paymentMethodData, setPaymentMethodData] = useState([])
    const [processorData, setProcessorData] = useState([])
    const [approvalData, setApprovalData] = useState([])
    const [approvalLoader, setApprovalLoader] = useState(false)
    const [approveReqLoader, setApproveReqLoader] = useState("")
    const [pageNo, setPageNo] = useState(1);
    const [pageLimit, setPageLimit] = useState(PAGE_LIST[2]);
    const [totalDataCount, setTotalDataCount] = useState(100);
    const [timezone, setTimezone] = useState("");
    const [isRejectModalData, setIsRejectModalData] = useState(null)
    const searchRef = useRef(null)
    const { getAllPspConfigs, getPaymentMethod, getAllTransactionDetails, merchantSettings, approveRefundRequest, setApprovalCount, approvalCount } = useAuth()

    function expandLogoDetails(transactionData) {
        return transactionData.map((item) => {
            const filteredData = paymentMethodData.filter((paymentItem) =>
                item.paymentMethodSubType === paymentItem.brand
                    ? paymentItem.logoUrl
                    : ""
            );
            const filteredProcessorData = processorData.find(
                (processorItem) =>
                    item?.pspCode === processorItem?.pspCode ||
                    item?.pspCode === processorItem?.title
            );
            let expandedData = {
                ...item,
                pspCode:
                    filteredProcessorData?.title === undefined
                        ? item.pspCode
                        : filteredProcessorData?.title,
                paymentMethodLogoUrl: item.paymentMethodLogoUrl || (filteredData?.length > 0 ? filteredData[0].logoUrl : ""),
                pspCodeLogoURL: filteredProcessorData
                    ? filteredProcessorData.pspLogoUrl
                    : "",
                categoryDataForSorting: {
                    type: item?.paymentMethodType,
                    subType: item?.paymentMethodSubType,
                },
            };
            return expandedData;
        });
    }
    const handleClearSearch = () => {
        if (searchRef.current) {
            searchRef.current.clearInput();
        }
    };

    function getApprovalData(attrName, values) {
        setApprovalLoader(true)
        let search = [];
        if (Array.isArray(values) || values?.length > 0) {
            const orderSearch = {
                attrName: attrName,
                operator: "containsIgnoreCase",
                values: [values],
            }
            search.push(orderSearch);
        }
        const filters = {}
        if (value == 0) {
            filters['reviewWorkflowStatus.status'] = ["REVIEW_PENDING"]
        } else {
            filters['reviewWorkflowStatus.status'] = ["REVIEWED", "DECLINED"]
        }
        const currentDate = new Date();
        let fromDate, toDate;
        const currentYear = currentDate.getFullYear();
        toDate = new Date();
        toDate.setHours(23, 59, 59, 999);
        fromDate = new Date(toDate);
        fromDate.setMonth(fromDate.getMonth() - 13);
        fromDate.setHours(0, 0, 0, 0);


        let reqData = {
            fromDate: fromDate,
            toDate: toDate,
            attributeFilters: filters,
            advancedAttributeFilters: search,
            limit: pageLimit, // pagination
            offset: (pageNo - 1) * pageLimit // pagination
        };
        if (timezone) {
            getAllTransactionDetails(reqData, function (paymentData) {
                const filterData = paymentData.points.map((rawData) => {
                    if (!rawData?.paymentMethodType && rawData?.emiMethod) {
                        rawData.paymentMethodType = "Emi";
                        rawData.paymentMethodTypeLocale = "EMI";
                    }
                    return rawData;
                });
                setApprovalData(filterData)
                setApprovalLoader();
                if (value == 0) {
                    if (!search?.length) {

                        setApprovalCount(paymentData.totalCount)
                    }
                }
                setTotalDataCount(paymentData.totalCount);
            },
                function (errorMsg) {
                    setApprovalLoader(false);
                },
            );
        }
    }
    const handleChange = (e, newValue) => {
        handleClearSearch()
        setValue(newValue);
        setPageLimit(PAGE_LIST[2])
        setTotalDataCount(100)

    };
    const postAction = (data) => {
        setApprovalData(state => state.filter(el => el.operationId !== data.operationId))
        setApprovalCount(state => state - 1)
    }
    const approveTransactionRequest = async (data) => {
        try {
            setApproveReqLoader(data.operationId)
            approveRefundRequest(data.transactionId, data.operationId, () => {
                customToast("success", "high", `Request approved for “${data.userId}”`)
                setApproveReqLoader("")
                postAction(data)
            }, (errorMsg) => {
                setApproveReqLoader("")
                customToast("error", "high", errorMsg || "Something went wrong")
            })
        } catch (err) {
            customToast("error", "high", "Something went wrong")
        }
    }
    useEffect(() => {
        merchantSettings(
            function (data) {
                setTimezone(data?.timeZone);
            },
            function (errorMsg) {
                customToast("error", "high", errorMsg);
            }
        );
        getAllPspConfigs((data) => {
            getPaymentMethod(
                function (paymentData) {
                    setPaymentMethodData(paymentData);
                },
                function (errorMsg) {
                    customToast("error", "high", errorMsg);
                }
            );
            setProcessorData(data)

        }, (errorMsg) => {
            customToast("error", "high", errorMsg);
        })
    }, [])

    useEffect(() => {
        if (timezone) {
            getApprovalData()
        }
    }, [timezone, value])

    return (
        <>
            <div className="content-wrapper" style={{ backgroundColor: "white" }}>
                <section className="content">
                    <Box sx={{ width: "100%" }}>
                        <TabContext value={value}>
                            <Box
                                sx={{
                                    borderBottom: 1,
                                    borderColor: "divider",
                                    width: approvalCount ? "350px" : "320px",
                                }}
                            >
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="basic tabs example"
                                    TabIndicatorProps={{
                                        sx: {
                                            background: colorBrandObject?.primaryButtonColor,
                                            height: 2,
                                        },
                                    }}
                                >
                                    <Tab sx={{
                                        fontFamily: "Poppins",
                                        fontSize: "16px",
                                        fontWeight: 600,
                                        textTransform: "none",
                                        color: value === "0" ? `${colorBrandObject?.primaryButtonColor} !important` : "gray",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                    }}
                                        label={
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                {approvalCount > 0 && <Box
                                                    sx={{
                                                        backgroundColor: colorBrandObject?.primaryButtonColor,
                                                        color: "white",
                                                        borderRadius: "50%",
                                                        width: "21px",
                                                        height: "21px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontSize: "12px",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {approvalCount}
                                                </Box>}
                                                Pending Approvals
                                            </Box>
                                        }
                                        value="0"
                                    />
                                    <Tab
                                        sx={{
                                            fontFamily: "Poppins",
                                            fontSize: "16px",
                                            fontWeight: 600,
                                            textTransform: "none",
                                            color: value === "1" ? `${colorBrandObject?.primaryButtonColor} !important` : "gray",
                                        }}
                                        label="Completed"
                                        value="1"
                                    />
                                </Tabs>
                            </Box>                            <Box style={{ width: "100%" }}>
                                <div className='mt-3'>

                                    {value && <InputSearch
                                        ref={searchRef}
                                        dropdownOptions={[
                                            { value: "transactionId", label: "Transaction ID" },
                                        ]}
                                        onSearch={(attrName, value) => getApprovalData(attrName, value)}
                                        placeholder="Search"
                                        defaultSearchAttribute="transactionId"
                                        customStyles={{ container: { width: "70%" }, dropdownToggle: { minWidth: "unset" } }}
                                    />}
                                </div>

                                <TabPanel value="0" className="orderManagement">
                                    <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
                                        <div style={{ width: "70%" }}></div>
                                        <div style={{ width: "30%", display: "flex", justifyContent: "flex-end" }}>
                                        </div>
                                    </div>
                                    <div>
                                        <BoxPayGrid
                                            schema={approvalWorkflowSchema(approveTransactionRequest, approveReqLoader, setIsRejectModalData)}
                                            loader={approvalLoader}
                                            data={expandLogoDetails(approvalData)}
                                            showCustomizeButton={false}
                                            customPagination={true}
                                            pageNo={pageNo}
                                            setPageNo={setPageNo}
                                            pageLimit={pageLimit}
                                            setPageLimit={setPageLimit}
                                            totalDataCount={totalDataCount}
                                            emptyText="No Pending Request"

                                        />
                                    </div>
                                </TabPanel>
                                <TabPanel value="1" className="orderManagement">
                                    <div style={{ display: "flex", width: "100%" }}>
                                        <div style={{ width: "70%" }}></div>
                                    </div>
                                    <div>
                                        <BoxPayGrid
                                            schema={completedWorkflowSchema()}
                                            loader={approvalLoader}
                                            data={expandLogoDetails(approvalData)}
                                            showCustomizeButton={false}
                                            customPagination={true}
                                            pageNo={pageNo}
                                            setPageNo={setPageNo}
                                            pageLimit={pageLimit}
                                            setPageLimit={setPageLimit}
                                            totalDataCount={totalDataCount}
                                        />
                                    </div>
                                </TabPanel>
                            </Box>
                        </TabContext>
                    </Box>
                </section>
            </div>
            {isRejectModalData && <RejectModal modalData={isRejectModalData} setModalData={setIsRejectModalData} postAction={postAction} />}
        </>
    );
}

export default ApprovalRequest;
